import type {
    CreateFtoTaskRequest,
    CreateFtoTaskResponse,
    UploadImagesResponse,
} from './types';

/**
 * FTO API 接口
 * @description 提供FTO相关的所有 API 调用
 */
export interface FtoApi {
    /**
     * 创建FTO任务
     * @param data 创建任务的请求参数
     * @returns 创建任务的响应数据
     */
    createFtoTask(data: CreateFtoTaskRequest): Promise<CreateFtoTaskResponse>;

    /**
     * 上传图片
     * @param files 图片文件列表
     * @param onProgress 上传进度回调
     * @returns 上传响应
     */
    uploadImages(files: File[], onProgress?: (progress: { percentage: number }) => void): Promise<UploadImagesResponse>;
}

/**
 * FtoApi 的 IOC 注入标识符
 */
export const FtoApi = Symbol('FtoApi');
